import { Trophy } from 'lucide-react'
import { useSeasonSummary } from '@/hooks/useSeasonSummary'

interface SeasonSummaryBannerProps {
  leagueId: string | undefined
  season: string
}

export function SeasonSummaryBanner({ leagueId, season }: SeasonSummaryBannerProps) {
  const { data: summary, isLoading } = useSeasonSummary(leagueId, season)

  if (isLoading || !summary) return null

  return (
    <div className="mb-6 rounded-xl border border-amber-200 dark:border-amber-800 bg-gradient-to-br from-amber-50 to-orange-50 dark:from-amber-950/30 dark:to-orange-950/20 p-5">
      <div className="flex items-center gap-2 mb-3">
        <Trophy className="h-5 w-5 text-amber-500" />
        <h3 className="text-sm font-semibold text-amber-900 dark:text-amber-200 uppercase tracking-wider">
          Season Wrap-Up
        </h3>
      </div>
      <p className="text-sm text-zinc-700 dark:text-zinc-300 whitespace-pre-wrap leading-relaxed">
        {summary.content}
      </p>
    </div>
  )
}
